import styled from "styled-components";
import { Text } from "@gcs/design-system/react";

export const SectionExecutiveContainer = styled.section(({ theme }) => ({
  backgroundColor: theme.color.neutral["07"],
}));

export const SectionExecutiveContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "64px",
  paddingTop: "40px",
  paddingBottom: "40px",

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const SectionExecutiveBlock = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
}));

export const SectionExecutiveBlockTitle = styled.h2(({ theme }) => ({
  fontSize: "32px",
  fontWeight: "700",
  margin: "0",
  color: theme.color.brandPrimary.light,

  [theme.breakpoint.lg()]: {
    fontSize: "40px",
  },
}));

export const SectionExecutiveBlockDescription = styled(Text)(() => ({
  fontWeight: "500",
}));

export const SectionExecutiveCard = styled.div(({ theme }) => ({
  maxWidth: "100%",
  width: "100%",

  [theme.breakpoint.lg()]: {
    maxWidth: "280px",
  },
}));

export const SectionExecutiveCardImage = styled.img(() => ({
  objectFit: "cover",
  width: "100%",
}));

export const SectionExecutiveCardContent = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const SectionExecutiveCardTitle = styled(Text)(({ theme }) => ({
  color: theme.color.brandPrimary.light,

  [theme.breakpoint.lg()]: {
    fontSize: "32px",
  },
}));

export const SectionExecutiveCardDescription = styled(Text)(({ theme }) => ({
  fontWeight: "500",

  [theme.breakpoint.lg()]: {
    fontSize: "20px",
  },
}));
